import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import { HeroLayout } from '@primer/gatsby-theme-doctocat';
export const _frontmatter = {
  "title": "Doctocat"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Doctocat makes it easy to set up a documentation site so you can focus on what's important: `}<em parentName="p">{`writing docs`}</em>{`.`}</p>
    <h2>{`Resources`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/getting-started"
        }}>{`Getting started`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/contributing"
        }}>{`Contributing`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/primer/doctocat"
        }}>{`GitHub`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      